import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';


const StyledTextField = styled(TextField)(({ theme }) => ({
    margin: 0,
    backgroundColor: '#FFFFFF',
    '& .MuiInputLabel-root': {
        fontSize: '16px',
        color: '#999999',
        transform: 'translate(17px, 13px) scale(1)',
        transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
        '&.Mui-focused': {
            transform: 'translate(17px, 4px) scale(1)',
            color: '#999999'
        },
        '&.MuiInputLabel-shrink': {
            fontSize: '13px',
            transform: 'translate(17px, 4px) scale(1)',
        }
    },
    '& .MuiOutlinedInput-root': {
        backgroundColor: '#FFFFFF',
        padding: '8px 17px 8px',
        '& .MuiOutlinedInput-notchedOutline legend': {
            display: 'none',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#EAECF0',
            borderRadius: '12px'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#EAECF0'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#EAECF0',
            borderWidth: '1px'
        }
    },
    '& .MuiOutlinedInput-input': {
        fontSize: '16px',
        padding: '12px 0 0 0',
        height: '28px',
        color: '#000000',
        '&::placeholder': {
            opacity: 1,
            color: '#DDDDDD'
        }
    },
    '& .MuiInputBase-inputMultiline': {
        padding: '16px 0 0 0',
    },
    '& input:-webkit-autofill': {
        'WebkitBoxShadow': '0 0 0 1000px white inset',
        'WebkitTextFillColor': '#000000',
        height: '32px'
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#EAECF0'
    },
    '& :hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#EAECF0'
    }
}));

export default StyledTextField;